import React from 'react';
import { FaUser, FaCrown, FaUserCheck } from 'react-icons/fa';
import { useT } from '../../contexts/LocaleContext.jsx';
import '../../styles/partial/UserRoleBadge.css';

const UserRoleBadge = ({ role, size = 'small', className = '' }) => {
  const t = useT();
  const getRoleConfig = () => {
    switch (role) {
      case 'member':
        return {
          icon: FaCrown,
          label: t('moderators.roles.member'),
          className: 'user-role-badge-member'
        };
      case 'moderator':
        return {
          icon: FaUserCheck,
          label: t('moderators.roles.moderator'),
          className: 'user-role-badge-moderator'
        };
      default:
        return {
          icon: FaUser,
          label: t('moderators.roles.user'),
          className: 'user-role-badge-user'
        };
    }
  };

  const config = getRoleConfig();
  const Icon = config.icon;

  return (
    <span 
      className={`user-role-badge ${config.className} user-role-badge-${size} ${className}`}
      title={config.label}
    >
      <Icon className="user-role-badge-icon" />
      <span className="user-role-badge-text">{config.label}</span>
    </span>
  );
};

export default UserRoleBadge;